import { useContext, useEffect, useState } from "react";

import "./Result.css";

//components
import { returnType } from "../../Helper_functions/Helper_functions";
import {
  componentNameType,
  componentsNamesFactoryForTitle,
} from "../../Helper_functions/Languages/LanguageSelector";
import { TitleCard } from "../../components/Card/TitleCard";
import { CoreButtonGroup } from "../../components/CoreButtonGroup/CoreButtonGroup";
import TabTable from "../../components/TabTable/TabTable";
import Table from "../../components/Table/Table";
import { LanguageContext } from "../../context/languageContext";
import { LanguageIdContext } from "../../context/languageIdContext";
import { Model } from "survey-react";

interface Result_Int {
  // data from survey
  data: any;
  back_button_clicked: () => void;
  clearSurvey: () => void;
  back_to_start_clicked: () => void;
  survey:Model | null;
}

export default function Result({
  data,
  back_button_clicked,
  clearSurvey,
  back_to_start_clicked,
  survey
}: Result_Int) {
  // context
  
  const { languageId } = useContext(LanguageIdContext);

  const [loading, setLoading] = useState(true);

  const [p1, setP1] = useState(0);
  const [p2, setP2] = useState(0);
  const [p3, setP3] = useState(0);
  const [p4, setP4] = useState(0);
  const [total, setTotal] = useState(0);
  const [objectData, setObjectData] = useState<any>({});
  const [type, setType] = useState<componentNameType>("");

  const [local_language, setLocal_language] = useState("");
  const [second_language, setSecond_language] = useState("");
  const [third_language, setThird_language] = useState("");

  const [org, setOrg] = useState("");
  const [date, setDate] = useState("");
  useEffect(() => {
    const CalculateTheResult = (data: any) => {
      let map = new Map();
      map.set("1", 0);
      map.set("2", 0);
      map.set("3", 0);
      map.set("4", 0);
      let total = 0;

      //check if data is there
      if (data == undefined) {
        let save_data = window.localStorage.getItem("my-survey");
        if (save_data) {
          data = JSON.parse(save_data);
        }
      }
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          if (key.includes("Num_quest")) {
            map.set(data[key], Number(map.get(data[key])) + 1);
            total += 1;
          }
          if (key.includes("local_language")) {
            setLocal_language(data[key]);
          }
          if (key.includes("second_language")) {
            setSecond_language(data[key]);
          }
          if (key.includes("other_language")) {
            setThird_language(data[key]);
          }

          if (key.includes("org_name")) {
            setOrg(data[key]);
          }
        }
      }

      setP1(Number(map.get("1")));
      setP2(Number(map.get("2")));
      setP3(Number(map.get("3")));
      setP4(Number(map.get("4")));
      setTotal(total);

      setType(returnType(p1, p2, p3, p4));

      setDate(get_date_string);
      setObjectData({
        p1: p1,
        p2: p2,
        p3: p3,
        p4: p4,
        total: total,
        date: date,
        data: data,
      });

      setLoading(false);
    };

    CalculateTheResult(data);
  }, [type]);

  if (loading) {
    return <div className={"container"}> loading</div>;
  }
  return (
    <div className="container">
      <div className="sub-container">
        <TitleCard
          title={componentsNamesFactoryForTitle(
            languageId,
            "Your Multilingualism Type"
          )}
          body={componentsNamesFactoryForTitle(languageId, type)}
        />
        <Table tally_1={p1} tally_2={p2} tally_3={p3} tally_4={p4} />
        <CoreButtonGroup
          back_to_start_clicked={back_to_start_clicked}
          back_button_clicked={back_button_clicked}
          clearSurvey={clearSurvey}
          Data={objectData}
          CsvFileName={`mat_facilitator_${org}_${date}`}
          survey={survey}
        />
      </div>
      <TabTable
        p1={p1}
        p2={p2}
        p3={p3}
        p4={p4}
        local_language={local_language}
        second_language={second_language}
        third_language={third_language}
      />
    </div>
  );
}

const get_month_for_num = (date: number) => {
  switch (date) {
    case 1:
      return "Jan";
    case 2:
      return "Feb";
    case 3:
      return "Mar";
    case 4:
      return "Apr";
    case 5:
      return "May";
    case 6:
      return "Jun";
    case 7:
      return "Jul";
    case 8:
      return "Aug";
    case 9:
      return "Sep";
    case 10:
      return "Oct";
    case 11:
      return "Nov";
    case 12:
      return "Dec";

    default:
      return "Jan";
  }
};

const get_date_string = () => {
  let date = new Date();

  let day = date.getDate();
  let month = get_month_for_num(date.getMonth() + 1);
  let year = date.getFullYear();
  return `${day}-${month}-${year}`;
};
